module.exports = __webpack_public_path__ + "static/spidergap-bc5e71cb93d85448f6df85f79c6c66bb.png";